export default "__VITE_ASSET__bef95e51__"